import React, { useState } from 'react'
import { Typography, Box } from '@mui/material'

// Local imports
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import AdxButton from 'components/custom/AdxButton'

const AdxLeaveDeleteModal = ({ state, deleteFn }) => {
  const [modalState, setModalState] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <>
      <AdxButton
        variant={'ghost'}
        sx={{ width: { xs: 100, lg: 100 } }}
        color="error"
        onClick={handleOpen}
      >
        Delete
      </AdxButton>
      <AdxInfoModal
        variant={'error'}
        title="Are you sure you want to remove this?"
        subtitle=""
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        footerButtons
        firstBtnLabel={'Delete'}
        firstBtnHandle={() => deleteFn()}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      >
        <Box mb={2}>
          <Typography align="center" variant="body1" color="dark-text.main">
            {state.name}
          </Typography>
        </Box>
        {/* <AdxButton
          variant={'outlined'}
          color="error"
          fullWidth
          onClick={() => deleteFn()}
          sx={{
            '&:hover': {
              backgroundColor: 'light-error.main',
            },
          }}
        >
          Delete
        </AdxButton>
        <AdxButton variant={'ghost'} fullWidth onClick={handleClose}>
          Cancel
        </AdxButton> */}
      </AdxInfoModal>
    </>
  )
}

export default AdxLeaveDeleteModal
